import React from 'react';
import { Link } from 'react-router-dom';
import HeaderSlider from '../../pages/HeaderSlider';


const TempStaffing = () => {
    return (
        <>
            {/* <!-- Breadcromb Area Start --> */}
            <section className="bleezy-breadcromb-area">
                <HeaderSlider src="../../assets/img/gallery-3.jpg" title="Temp Staffing" />

                {/* <div className="breadcromb-top temp-staff">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-top-text">
                                    <h2 className="banner-heading">Temp Staffing</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className="breadcromb-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-bottom-text">
                                    <ul>
                                        <li><Link to="/">home</Link></li>
                                        <li><a href="#"><i className="fa fa-long-arrow-right"></i></a></li>
                                        <li>Temp Staffing</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Breadcromb Area End --> */}

            <section class="bleezy-blog-page-area" style={{ paddingTop: '15px', paddingBottom: '15px' }}>
                <div class="container">
                    <div class="mid-title  mb-5 "><h2 class="heading-with-border"><strong>Temp Staffing</strong></h2>
                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                            At times, you do not need a staff on permanent basis as the requirement is temporary in nature. It may be due to seasonal nature of work, servicing a new contract, prolong leave of regular staff or reluctance in hiring a permanent staff. Temporary Staff is ideal in such situations, as it does not create a burden on you. Temp staff in India enable you to replace the non performing ones without bothering about the replacement cost. It is our endeavor to be leading Contract Staffing Company in India.
                        </p>
                        <h3 className="sub-heading-page sub-heading-m-t-15 sub-heading-m-b-15"><strong>We provide Temporary Staffing Service for the post of:</strong></h3>

                        <ul class="list">
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Accountant</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Back office executive</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Salesman or salesgirl</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Tele Caller</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Data Entry Operator</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Field Staff</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Receptionist</li>
                        </ul>

                        <h3 className="sub-heading-page sub-heading-m-t-15 sub-heading-m-b-15"><strong>Advantages of Contract Staffing Service:</strong></h3>

                        <ul class="list">
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Dual benefit of hiring all security needs and event staffing solution under one roof</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Hire when required</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Partner with us for your expansion program</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Manage payroll</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Compliance with PF, ESIC, etc.</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Replacement for non-performer</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Trained staff</li>
                        </ul>

                        <p className="octo-para sub-heading-m-t-15 sub-heading-m-b-15">
                            If you are looking to hire temporary staff in India, contact us for the best offers. You may also transfer your existing employees on our payroll to reap the above benefits. Our Temp staff solution is currently available in India only.
                        </p>

                    </div>
                </div>
            </section>

        </>
    )
}

export default TempStaffing;
